import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

export const EncryptedWalletPropsSchema = z.object({
  data: z.string(),
  iv: z.string(),
  salt: z.string(),
})

export type EncryptedWalletProps = z.infer<typeof EncryptedWalletPropsSchema>

export class EncryptedWallet extends ValueObject<EncryptedWalletProps> {
  public get data(): string {
    return this.props.data
  }

  public get iv(): string {
    return this.props.iv
  }

  public get salt(): string {
    return this.props.salt
  }

  public static create(props: EncryptedWalletProps): EncryptedWallet {
    const validatedProps = EncryptedWalletPropsSchema.parse(props)
    return new EncryptedWallet(validatedProps)
  }
}
